var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4607_50271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 16.4444C14.8784 17.6388 12.9703 18.3005 11.0003 18.3327C4.58366 18.3327 0.916992 10.9994 0.916992 10.9994C2.05722 8.87444 3.6387 7.01793 5.55533 5.55437M9.07532 3.88604C9.7063 3.73834 10.3523 3.66452 11.0003 3.66604C17.417 3.66604 21.0837 10.9994 21.0837 10.9994C20.5272 12.0403 19.8636 13.0204 19.1037 13.9235M12.9437 12.9427C12.6919 13.2129 12.3883 13.4296 12.051 13.5799C11.7136 13.7302 11.3495 13.811 10.9802 13.8175C10.611 13.8241 10.2442 13.7561 9.9018 13.6178C9.55938 13.4795 9.24832 13.2736 8.98718 13.0125C8.72605 12.7514 8.52019 12.4403 8.38188 12.0979C8.24356 11.7555 8.17564 11.3887 8.18216 11.0195C8.18867 10.6502 8.26949 10.2861 8.4198 9.94873C8.5701 9.6114 8.78681 9.3078 9.05699 9.05604",
    stroke: "#B30200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 0.916016L21.0837 21.0827",
    stroke: "#B30200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4607_50271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.4e9fb0a7b7e40e16aaae8fea9c54b886.svg";
export { ForwardRef as ReactComponent };